import { useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { ADMIN_TOAST_EVENT, ToastPayload, ToastSeverity } from "../../utils/toast";

export default function AppToast() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<ToastSeverity>("info");

  useEffect(() => {
    const onToast = (event: Event) => {
      const customEvent = event as CustomEvent<ToastPayload>;
      const payload = customEvent.detail;
      if (!payload?.message) return;
      setMessage(payload.message);
      setSeverity(payload.severity || "info");
      setOpen(true);
    };

    window.addEventListener(ADMIN_TOAST_EVENT, onToast as EventListener);
    return () => {
      window.removeEventListener(ADMIN_TOAST_EVENT, onToast as EventListener);
    };
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={() => setOpen(false)}
        severity={severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
